module.exports = __webpack_public_path__ + "img/icon5.2d4f08d6.png";